import useI18n from "../../i18n/useI18n";

// Keyboard-accessible skip link — visible only when focused.
const SkipLink = () => {
  const { t } = useI18n();
  return (
    <a className="skip-link" href="#main-content">
      {t("nav.skip")}
    </a>
  );
};

export default SkipLink;
